'use client'

import avatarIcon from '@public/images/avatar.svg'
import cartIcon from '@public/images/cart.svg'
import Image from 'next/image'
import Link from 'next/link'

import { Container } from '@src/components/Container/Container'
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context'
import { useCart } from '@src/hooks/useCart'
import { useSession } from '@src/hooks/useSession'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'
import { getCartQuantity } from '@src/utils/cart.util'
import { cn } from '@src/utils/tailwind'

export const TopNavV5MobileBar = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { t } = useLocale('common')
  const cart = useCart()
  const quantity = getCartQuantity(cart.cart)
  const { user } = useSession()
  const { logo, setAccountExpanded, mobileDispatch } = useTopNavV5()

  const renderHamburger = () => {
    return (
      <button
        data-testid="topNavMobileMenu"
        onClick={() => {
          mobileDispatch({ type: 'OPEN' })
        }}
        className="flex size-6 appearance-none flex-col items-center justify-center
        *:h-0.5 *:w-6 *:rounded-sm *:bg-white *:transition-all"
      >
        <div className="-translate-y-1"></div>
        <div></div>
        <div className="translate-y-1"></div>
      </button>
    )
  }

  return (
    <Container className="h-full *:h-full">
      <div className="flex h-full flex-row items-center justify-between">
        <div className="flex gap-6">
          <div className="flex items-center">{renderHamburger()}</div>
          {logo?.src && (
            <LocalizedLink
              onClick={() => {
                trackSelectNavCta({ 'cta url': logo?.href })
              }}
              href={logo?.href ?? ''}
            >
              <Image
                src={logo.src}
                width={logo?.mobileWidth}
                height={logo?.mobileHeight}
                alt={logo?.altText ?? ''}
              />
            </LocalizedLink>
          )}
        </div>
        <div className="flex gap-3">
          <Link data-testid="cartBtn" href="#cart" className="relative mt-0.5 mr-1">
            <Image src={cartIcon} width={24} height={24} alt={t('view-cart')} />
            {quantity ? (
              <div
                className={cn(
                  'absolute top-0 left-full -mt-3 ml-[-18px] flex min-h-[24px] min-w-[24px] items-center justify-center rounded-full border-2 border-bodi-black-text bg-bodi-green-bright-500 text-body-xs font-semibold text-bodi-black',
                  { 'px-1.5': quantity > 99 }
                )}
              >
                {quantity > 999 ? '999' : quantity}
              </div>
            ) : null}
          </Link>
          <button
            onClick={() => {
              setAccountExpanded(true)
            }}
            data-testid="bodiBtn"
            className="flex items-center gap-2 font-medium text-bodi-gray-butters"
          >
            <Image src={avatarIcon} width={24} height={24} alt="Account icon" />
            {user ? t('my-account') : t('login-join')}
          </button>
        </div>
      </div>
    </Container>
  )
}
